// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"85091f8b","453":"54292a4b","560":"11163e17","755":"1fe59236","783":"5db6a2f6"}[chunkId] + ".chunk.js";
};